import { render, staticRenderFns } from "./TheNavBar.vue?vue&type=template&id=96f64b42&"
import script from "./TheNavBar.vue?vue&type=script&lang=ts&"
export * from "./TheNavBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports